import React from 'react';
import Input from '../../../components/ui/Input';

const ClientInformationSection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="space-y-6">
      <div className="border-b border-border pb-4">
        <h3 className="text-xl font-semibold text-foreground mb-2">Client Information</h3>
        <p className="text-text-secondary text-sm">
          Please provide your contact details and company information
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="First Name"
          type="text"
          name="firstName"
          placeholder="Enter your first name"
          value={formData?.firstName}
          onChange={handleInputChange}
          error={errors?.firstName}
          required
          className="focus:border-accent"
        />

        <Input
          label="Last Name"
          type="text"
          name="lastName"
          placeholder="Enter your last name"
          value={formData?.lastName}
          onChange={handleInputChange}
          error={errors?.lastName}
          required
          className="focus:border-accent"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Email Address"
          type="email"
          name="email"
          placeholder="your.email@company.com"
          value={formData?.email}
          onChange={handleInputChange}
          error={errors?.email}
          required
          description="We'll use this for project communications"
          className="focus:border-accent"
        />

        <Input
          label="Phone Number"
          type="tel"
          name="phone"
          placeholder="+1 240-598-5442"
          value={formData?.phone}
          onChange={handleInputChange}
          error={errors?.phone}
          required
          className="focus:border-accent"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Company Name"
          type="text"
          name="companyName"
          placeholder="Your Company Ltd."
          value={formData?.companyName}
          onChange={handleInputChange}
          error={errors?.companyName}
          required
          className="focus:border-accent"
        />

        <Input
          label="Job Title"
          type="text"
          name="jobTitle"
          placeholder="CEO, CTO, Product Manager, Self-employed, etc."
          value={formData?.jobTitle}
          onChange={handleInputChange}
          error={errors?.jobTitle}
          required
          className="focus:border-accent"
        />
      </div>
      <Input
        label="Company Website"
        type="url"
        name="website"
        placeholder="https://yourcompany.com"
        value={formData?.website}
        onChange={handleInputChange}
        error={errors?.website}
        description="Optional - helps us understand your business better"
        className="focus:border-accent"
      />
    </div>
  );
};

export default ClientInformationSection;